
  export default {
    name: `UploadDropCard`,
    props: {
      title: { type: String, required: true },
      accept: { type: String, default: `image/*,application/pdf` },
      preview: { type: String, default: null }
    },
    data() {
      return { dragging: false, pdfFile: null, converting: false }
    },
    components: {
      PdfToImage: () => import("./PdfToImage.vue")
    },
    methods: {
      openFileDialog() {
        this.$refs.fileInput && this.$refs.fileInput.click()
      },
      onDragOver() {
        this.dragging = true
      },
      onDragLeave() {
        this.dragging = false
      },
      onDrop(event) {
        this.dragging = false
        const files = event?.dataTransfer?.files
        if (!files || !files.length) return
        this.readAndEmit(files[0])
      },
      onChange(event) {
        const file = event?.target?.files?.[0]
        if (event?.target) {
          event.target.value = ``
        }
        if (!file) return
        this.readAndEmit(file)
      },
      readAndEmit(file) {
        if (file?.type?.includes("pdf")) {
          this.pdfFile = file
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => this.$emit("file-selected", { file, preview: e.target.result })
        reader.readAsDataURL(file)
      },
      onClear() {
        this.$emit(`clear`)
        this.pdfFile = null
      },
      onPdfConverted({ image, fileName }) {
        // Convert base64 to File for consistency with image uploads
        const file = this.base64ToFile(image, fileName, "image/jpeg")
        this.$emit("file-selected", { file, preview: image })
        this.pdfFile = null
      },
      onPdfError() {
        // Keep pdfFile to allow retry or clear
        // Optionally could flash an error here
      },
      onPdfCancel() {
        this.pdfFile = null
      },
      base64ToFile(base64, filename, mime) {
        const arr = base64.split(",")
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, { type: mime })
      }
    }
  }
